// ToggleSwitch.jsx
import React from 'react';
import './ToggleSwitch.css';  

const ToggleSwitch = ({
  isChecked,
  onToggle,
  label,
  name,
  disabled = false,
  className = '',
}) => {
  return (
    <div className={`d-flex align-items-center ${className}`}>
      <div className={`toggle-switch ${isChecked ? 'active' : ''}`}>
        <label className="switch">
          <input
            type="checkbox"
            name={name}
            checked={isChecked}
            onChange={onToggle}
            disabled={disabled}
          />
          <span className="slider round"></span>
        </label>
      </div>
      {label && <span className="ms-1 mb-1">{label}</span>}
    </div>
  );
};

export default ToggleSwitch;